<template>
  <section class="my-returns-cancelled">
    <div class="account-content">
      <div class="account-content__header">
        <div class="wrapp-title">
          <svg class="o-icon stroke-black"><use xlink:href="#close"></use></svg>
          <span class="text ml-3">{{$t('returns.cancelled.title')}}</span>
        </div>
        <div class="wrapp-subtitle">
          <p>{{$t('returns.cancelled.subtitle')}}</p>
        </div>
        <div class="wrapp-ctas d-flex flex-column">
          <button class="btn btn-primary btn-primary-small btn-primary-with-icon btn-rounded mx-auto mb-3">
            <span class="text">{{$t('return-refund-area')}}</span>
            <svg class="o-icon fill-white"><use xlink:href="#return-order"></use></svg>
          </button>
          <router-link :to="{ name: 'home' }" class="btn btn-secondary btn-secondary-small btn-secondary-with-icon btn-rounded mx-auto">
            <span class="text">{{$t('go-to-shopping')}}</span>
            <svg class="o-icon fill-black"><use xlink:href="#your-shop"></use></svg>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ReturnCancelled',
  beforeMount () {
    if (process.client) {
      return this.$store.commit('ui/setHeaderPageTitle', 'refound-order')
    }
  }
}
</script>
